import { useAuthenticated } from 'src/hooks/useAuthenticated'

/**
 * Free and Standard vendors are the vendor users without LTH Premium (Engaged and Strategic include it). They already
 * have an account, so the free limit messages ask them to upgrade rather than to sign up.
 */
export const useIsFreeOrStandardVendor = () => {
  const { status, isVendor, isPremium } = useAuthenticated()
  return status === 'authenticated' && isVendor && !isPremium
}
